import { createAction, props } from '@ngrx/store';

export const loadReloads = createAction(
  '[Reload] Load Reloads'
);

export const loadReloadsSuccess = createAction(
  '[Reload] Reload Success'
);

export const loadReloadsFailure = createAction(
  '[Reload] Reload Failure'
);
